// Drops Web eID messages that do not come from this window and origin, so forged messages never reach the Web eID library.
// Keep in sync with the inline copy in src/index.html.
window.addEventListener(
  'message',
  (event) => {
    const action = event.data?.action;
    const isWebEid = typeof action === 'string' && action.startsWith('web-eid:');
    if (isWebEid && (event.source !== window || event.origin !== window.location.origin)) {
      event.stopImmediatePropagation();
    }
  },
  true,
);
